export default "__VITE_ASSET__fX1$367H__"